import DatabaseModel from './DatabaseModel.js';

var Inventario = Object.create(DatabaseModel);

Inventario.model = 'inventario';
Inventario.modelFront = 'inventario';

export default Inventario;